import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0ce296d0&scoped=true&lang=html&"
import script from "./payResult.js?vue&type=script&lang=js&"
export * from "./payResult.js?vue&type=script&lang=js&"
import style0 from "./payResult.styl?vue&type=style&index=0&id=0ce296d0&lang=stylus&scoped=true&"
import style1 from "./resetVant.styl?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce296d0",
  null
  
)

export default component.exports